<template>
    <div>
        <v-window v-model="step">
            <v-window-item value="priceListTable">
                <v-row no-gutters class="d-flex justify-start pt-2">
                    <!-- <v-col cols="3" class="pr-1">
                        <v-btn-primary
                            block
                            @click="
                                editPriceList(null);
                                priceList.version = 1;
                            "
                        >
                            Ajouter une grille tarifaire
                        </v-btn-primary>
                    </v-col> -->
                    <v-col cols="3" class="pl-1">
                        <v-btn-primary
                            block
                            @click="
                                priceList.version = 2;
                                editPriceList(null);
                            "
                            :disabled="disabledAdd"
                        >
                            Ajouter une grille tarifaire AGIRIS
                        </v-btn-primary>
                    </v-col>
                    <v-col cols="3" class="pl-1">
                        <v-select v-model="version" :items="versions" label="Version"> </v-select>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center pt-4">
                    <v-data-table
                        :headers="listHeaders"
                        :items="priceListItems"
                        fixed-header
                        style="width: 100%"
                        max-height="60vh"
                        :items-per-page-options="[5, 10, 25, -1]"
                        class="table"
                    >
                        <template v-slot:item="props">
                            <tr @click="editPriceList(props.item)">
                                <td class="text-left">{{ props.item.name }}</td>
                                <td class="text-left">{{ getPriceListType(props.item.type) }}</td>
                                <td class="text-left">{{ getPriceListScope(props.item.scope) }}</td>
                                <td class="text-left">
                                    {{ props.item.discountPercentage || "-" }}
                                </td>
                                <!-- <td class="text-left">{{ props.item.discount || "-"  }}</td> -->
                                <td class="text-left">{{ props.item.discountDuration || "-" }}</td>
                                <td class="text-left">{{ props.item.prices.length }}</td>
                                <td class="text-left">
                                    {{ props.item.accountingFirms.length }}
                                    <v-btn-icon
                                        icon=" $fa-user "
                                        color="secondary"
                                        elevation="0"
                                        size="small"
                                        @click.stop="showClientDialog(props.item)"
                                    />
                                </td>
                                <td class="text-center">
                                    <v-btn-icon icon=" $oss-edit " elevation="0" size="x-small" />
                                    <v-btn-icon
                                        icon="$oss-duplicate"
                                        class="pl-1"
                                        elevation="0"
                                        @click.stop="editPriceList(props.item, true)"
                                        data-cy="PriceList-duplicate"
                                        size="x-small"
                                    />
                                    <!-- <v-btn
                                        icon
                                        class="pl-1"
                                        elevation="0"
                                         size=“x-small”
                                        v-if="!props.item.accountingFirms.length"
                                        @click.stop="deletePriceList(props.item.id)"
                                    >
                                        <v-icon  size=“x-small”> $oss-trash </v-icon>
                                    </v-btn> -->
                                </td>
                                <td class="text-left">
                                    <v-switch
                                        v-model="props.item.deprecated"
                                        @change="modifyDepracated(props.item)"
                                        @click.stop=""
                                    />
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-row>
            </v-window-item>
            <v-window-item value="priceListData">
                <v-row no-gutters class="d-flex justify-start py-2">
                    <v-col cols="5" class="d-flex align-center">
                        <v-btn-back @click="back()"> </v-btn-back>
                        <v-text-field
                            v-model="priceList.name"
                            class="pl-2"
                            label="Nom"
                            required
                            outlined
                            hide-details
                            block
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" class="align-center">
                        <v-row no-gutters>
                            <v-col cols="6" class="pl-2">
                                <v-select
                                    v-model="priceList.type"
                                    :items="priceListTypes"
                                    label="Type"
                                    item-value="value"
                                    outlined
                                    hide-details
                                    block
                                    density="compact"
                                    :item-title="(item) => item.text"
                                />
                            </v-col>
                            <v-col cols="6" class="px-1">
                                <v-select
                                    v-model="priceList.scope"
                                    :items="priceListScopes"
                                    label="Perimètre"
                                    item-value="value"
                                    outlined
                                    hide-details
                                    block
                                    density="compact"
                                    :item-title="(item) => item.text"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="4" class="align-center">
                        <v-row no-gutters>
                            <v-col cols="4" class="px-1">
                                <oss-text-field-filled
                                    v-model="priceList.discountPercentage"
                                    label="Remise"
                                    suffix="%"
                                    required
                                    hide-details
                                    dense
                                    block
                                />
                            </v-col>
                            <v-col cols="4" class="px-1">
                                <oss-text-field-filled
                                    v-model="priceList.discountDuration"
                                    label="Duration"
                                    suffix="M"
                                    required
                                    hide-details
                                    dense
                                    block
                                />
                            </v-col>
                            <v-col cols="4" class="d-flex align-center justify-end pl-1">
                                <v-btn
                                    rounded
                                    elevation="0"
                                    :disabled="disabledSave"
                                    @click.stop="upsertPriceList()"
                                    size="small"
                                >
                                    {{ priceList.id ? "Modifier" : "Créer" }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center" v-if="priceList.version === 1">
                    <v-data-table
                        :headers="headers"
                        :items="priceList.prices"
                        :items-per-page="-1"
                        style="width: 100%"
                        class="table"
                    >
                        <template v-slot:item="{ item, index }">
                            <tr>
                                <td class="text-left px-0">{{ getTitle(item) }}</td>
                                <td>
                                    <oss-text-field-filled
                                        v-model="item.unitPrice"
                                        suffix="&#x20ac;"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                        :rules="[
                                            (v) =>
                                                (v !== '' && parseFloat(v) >= 0.0) ||
                                                $t('settings.positiveNumber'),
                                        ]"
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <v-switch v-model="item.withVAT" hide-details class="mt-0" />
                                </td>
                                <td class="pl-1 pr-0">
                                    <v-select-filled
                                        v-model="item.taxSystem"
                                        :items="taxSystems"
                                        item-value="value"
                                        outlined
                                        hide-details
                                        density="compact"
                                        :item-title="(item) => item.text"
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.minAccountingLineCount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.maxAccountingLineCount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.discountPercentage"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        suffix="%"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.discount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        suffix="&#x20ac;"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.minQuantity"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <v-select-filled
                                        v-model="item.accountingType"
                                        :items="accountingTypes"
                                        item-value="value"
                                        outlined
                                        hide-details
                                        density="compact"
                                        :item-title="(item) => item.text"
                                    />
                                </td>
                                <td style="text-align: center" class="pl-1 pr-0">
                                    <v-btn-trash @click="deleteRow(index)" size="x-small" />
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append>
                            <tr>
                                <td class="text-left pl-0 pr-0">{{ getTitle(newPrice) }}</td>
                                <td>
                                    <oss-text-field-filled
                                        v-model="newPrice.unitPrice"
                                        suffix="&#x20ac;"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                        :rules="[
                                            (v) =>
                                                (v !== '' && parseFloat(v) >= 0.0) ||
                                                $t('settings.positiveNumber'),
                                        ]"
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <v-switch
                                        v-model="newPrice.withVAT"
                                        hide-details
                                        class="mt-0"
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <v-select-filled
                                        v-model="newPrice.taxSystem"
                                        :items="taxSystems"
                                        item-value="value"
                                        outlined
                                        hide-details
                                        density="compact"
                                        :item-title="(item) => item.text"
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.minAccountingLineCount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.maxAccountingLineCount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.discountPercentage"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        suffix="%"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.discount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        suffix="&#x20ac;"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.minQuantity"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <v-select-filled
                                        v-model="newPrice.accountingType"
                                        :items="accountingTypes"
                                        item-value="value"
                                        outlined
                                        hide-details
                                        density="compact"
                                        :item-title="(item) => item.text"
                                    />
                                </td>
                                <td class="text-center pl-1 pr-0">
                                    <v-btn-add-icon
                                        size="x-small"
                                        :disabled="invalidRow()"
                                        @click="addRow()"
                                    >
                                    </v-btn-add-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-row>
                <v-row no-gutters class="d-flex justify-center" v-else>
                    <v-data-table
                        :headers="headers"
                        :items="priceList.prices"
                        :items-per-page="-1"
                        style="width: 100%"
                        class="table"
                    >
                        <!-- <template v-slot:header.additionnalConnectorPrice>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <span v-bind="props">ACP</span>
                                </template>
                                <span>Prix supplémentaire du connecteur</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:header.additionnalAccountingLinePrice>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <span v-bind="props">AALP</span>
                                </template>
                                <span>Prix de la ligne comptable supplémentaire</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:header.maxConnectorCount>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <span v-bind="props">MCC</span>
                                </template>
                                <span>Nombre maximal de connecteurs</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:header.maxUserCount>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <span v-bind="props">MUC</span>
                                </template>
                                <span>Nombre maximal d'utilisateurs</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:header.additionalUserPrice>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <span v-bind="props">AUP</span>
                                </template>
                                <span>Prix pour utilisateur supplémentaire</span>
                            </v-tooltip>
                        </template> -->
                        <template v-slot:item="{ item, index }">
                            <tr>
                                <td class="pl-1 pr-0">
                                    <v-select-filled
                                        v-model="item.offer"
                                        :items="offerTypes"
                                        item-value="value"
                                        outlined
                                        hide-details
                                        density="compact"
                                        :item-title="(item) => item.text"
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.unitPrice"
                                        suffix="&#x20ac;"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                        :rules="[
                                            (v) =>
                                                (v !== '' && parseFloat(v) >= 0.0) ||
                                                $t('settings.positiveNumber'),
                                        ]"
                                    />
                                </td>
                                <!-- <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.minAccountingLineCount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.maxAccountingLineCount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.discountPercentage"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        suffix="%"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.discount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        suffix="&#x20ac;"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.minQuantity"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.additionnalConnectorPrice"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.additionnalAccountingLinePrice"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.maxConnectorCount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.maxUserCount"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="item.additionalUserPrice"
                                        content-class="oss-"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td> -->
                                <td style="text-align: center" class="pl-1 pr-0">
                                    <v-btn-trash @click="deleteRow(index)" size="x-small" />
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append>
                            <tr>
                                <td class="pl-1 pr-0">
                                    <v-select-filled
                                        v-model="newPrice.offer"
                                        :items="offerTypes"
                                        item-value="value"
                                        outlined
                                        hide-details
                                        density="compact"
                                        :item-title="(item) => item.text"
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.unitPrice"
                                        suffix="&#x20ac;"
                                        hide-details
                                        :rules="[
                                            (v) =>
                                                (v !== '' && parseFloat(v) >= 0.0) ||
                                                $t('settings.positiveNumber'),
                                        ]"
                                    />
                                </td>
                                <!-- <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.minAccountingLineCount"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.maxAccountingLineCount"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.discountPercentage"
                                        suffix="%"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.discount"
                                        suffix="&#x20ac;"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.minQuantity"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.additionnalConnectorPrice"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.additionnalAccountingLinePrice"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.maxConnectorCount"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.maxUserCount"
                                        hide-details
                                    />
                                </td>
                                <td class="pl-1 pr-0">
                                    <oss-text-field-filled
                                        v-model="newPrice.additionalUserPrice"
                                        hide-details
                                    />
                                </td> -->
                                <td class="text-center pl-1 pr-0">
                                    <v-btn
                                        fab
                                        size="x-small"
                                        color="primary"
                                        :disabled="invalidRow()"
                                        @click="addRow()"
                                        elevation="0"
                                        icon="$add"
                                    >
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-row>
            </v-window-item>
        </v-window>
        <oss-dialog v-model="clientListDialog" :title="priceListName" width="50vw">
            <div v-if="priceListClients.length">
                <v-row no-gutters class="justify-center">
                    <v-col cols="8" class="justify-center">
                        <v-list style="overflow-y: auto; max-height: 60vh" density="compact">
                            <v-list-item
                                class="mb-2 px-2"
                                v-for="(client, index) in priceListClients"
                                :key="index"
                            >
                                <template v-slot:append class="d-flex align-center justify-center">
                                    <v-icon> $fa-building </v-icon>
                                </template>

                                <v-list-item-title>{{ client.name }}</v-list-item-title
                                ><v-list-item-subtitle>
                                    SIRET : {{ client.siret.slice(0, 14) }}
                                </v-list-item-subtitle></v-list-item
                            >
                        </v-list>
                    </v-col>
                </v-row>
            </div>
            <div v-else class="body-1 text-center">
                Aucun client n'est associé à cette grille tarifaire
            </div>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import _ from "lodash";
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import { User } from "../../../store/store";

import PRICE_LISTS from "../../../graphql/billing/BobbeePriceLists.gql";
import UPSERT_PRICE_LIST from "../../../graphql/billing/UpsertPriceList.gql";
import DELETE_PRICE_LIST from "../../../graphql/billing/DeletePriceList.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {},
})
export class PriceList extends Vue {
    @Prop() value: boolean;

    version: number = 2;
    versions = [
        {
            value: 1,
            title: "bobbee",
        },
        {
            value: 2,
            title: "agiris",
        },
        {
            value: null,
            title: "Toutes",
        },
    ];

    step = "priceListTable";

    clientListDialog = false;
    priceListName = "";
    priceListClients = [];

    listHeaders = [
        { title: "Nom", value: "name", sortable: false },
        { title: "Type", value: "type", sortable: false },
        { title: "Perimètre", value: "scope" },
        { title: "Remise %", value: "discountPercentage", sortable: false },
        // { title: 'Remise', value: 'discount', sortable: false },
        { title: "Période de remise", value: "discountDuration", sortable: false },
        { title: "Prix", value: "prices", sortable: false },
        { title: "Clients", value: "accountingFirms", sortable: false },
        { title: "Action", value: "actions", sortable: false },
        { title: "Obsolète", value: "actions", sortable: false },
    ];

    priceListTypes = [{ text: "Standard", value: "STANDARD" }];

    priceListScopes = [
        { text: "Cabinet", value: "EXPERT" },
        { text: "Entreprise", value: "BUSINESS" },
    ];

    accountingTypes = [
        { text: "Trésorerie", value: "INCOMING_OUTGOING_PAYMENT" },
        { text: "Engagement", value: "RECEIVABLES_DEBT" },
    ];

    taxSystems = [
        { text: "BIC Simple", value: "BIC_Simplified" },
        { text: "BIC Normal", value: "BIC_Normal" },
        { text: "BNC", value: "BNC" },
        { text: "SCI", value: "RF" },
    ];

    defaultPrice = {
        id: "",
        title: "",
        accountingType: null,
        offer: null,
        taxSystem: null,
        withVAT: false,
        minAccountingLineCount: null,
        maxAccountingLineCount: null,
        unitPrice: null,
        discount: null,
        discountPercentage: null,
        minQuantity: null,
        invoiceProduct: null,
        maxConnectorCount: null,
        additionnalConnectorPrice: null,
        additionnalAccountingLinePrice: null,
        maxUserCount: null,
        additionalUserPrice: null,
    };

    newPrice = _.cloneDeep(this.defaultPrice);

    defaultPriceList = {
        id: "",
        name: "",
        type: "STANDARD",
        scope: "EXPERT",
        version: 1,
        discountPercentage: null,
        discountDuration: null,
        prices: [],
    };

    priceList = _.cloneDeep(this.defaultPriceList);

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingFirmId() {
        return this.currentUser.company.id;
    }

    get offerTypes() {
        return [
            { text: "Entreprise - Basique", value: "BUSINESS_BASIC" },
            { text: "Entreprise - Essentiel", value: "BUSINESS_ESSENTIAL" },
            { text: "Entreprise - Premium", value: "BUSINESS_PREMIUM" },
            { text: "Cabinet - Démarrage", value: "ACCOUNTING_STARTER" },
            { text: "Cabinet - Basique", value: "ACCOUNTING_BASIC" },
            { text: "Cabinet - Essentiel", value: "ACCOUNTING_ESSENTIAL" },
            { text: "Cabinet - Premium", value: "ACCOUNTING_PREMIUM" },
        ];
    }

    get headers() {
        const headers: any = [];
        if (this.priceList.version === 1) {
            headers.push(
                { title: "Titre", value: "title", sortable: false, width: "230px" },
                { title: "Prix unitaire", value: "unitPrice", sortable: false, width: "110px" },
                { title: "TVA", value: "withVAT", sortable: false },
                { title: "Régime", value: "taxSystem", sortable: false },
            );
        } else {
            headers.push(
                { title: "Offre", value: "offer", sortable: false, width: "300px" },
                { title: "Prix unitaire", value: "unitPrice", sortable: false, width: "95px" },
            );
        }
        if (this.priceList.version === 1) {
            headers.push(
                {
                    title: "Min lignes",
                    value: "minAccountingLineCount",
                    sortable: false,
                    width: "85px",
                },
                {
                    title: "Max lignes",
                    value: "maxAccountingLineCount",
                    sortable: false,
                    width: "85px",
                },
                { title: "Remise %", value: "discountPercentage", sortable: false, width: "95px" },
                { title: "Remise €", value: "discount", sortable: false, width: "95px" },
                { title: "Min qté", value: "minQuantity", sortable: false, width: "85px" },
            );
            if (this.priceList.version === 1) {
                headers.push({
                    title: "Type de comptabilité",
                    value: "accountingType",
                    sortable: false,
                    width: "180px",
                });
            } else {
                headers.push(
                    {
                        title: "ACP",
                        value: "additionnalConnectorPrice",
                        sortable: false,
                        width: "85px",
                    },
                    {
                        title: "AALP",
                        value: "additionnalAccountingLinePrice",
                        sortable: false,
                        width: "85px",
                    },
                    { title: "MCC", value: "maxConnectorCount", sortable: false, width: "85px" },
                    { title: "MUC", value: "maxUserCount", sortable: false, width: "85px" },
                    { title: "AUP", value: "additionalUserPrice", sortable: false, width: "85px" },
                );
            }
        }
        headers.push({ title: "Action", value: "action", sortable: false });
        return headers;
    }

    get disabledSave() {
        if (this.priceList.name && this.priceList.prices.length) {
            return false;
        }
        return true;
    }

    getPriceListType(type) {
        return this.priceListTypes.find((t) => t.value === type)?.text || "-";
    }

    getPriceListScope(scope) {
        return this.priceListScopes.find((t) => t.value === scope)?.text || "-";
    }

    getTitle(price) {
        let title = "";
        if (price.accountingType === "RECEIVABLES_DEBT") {
            title = "Compta d'engagement";
        } else if (price.accountingType === "INCOMING_OUTGOING_PAYMENT") {
            title = "Compta de trésorerie";
        }
        if (price.taxSystem) {
            if (price.taxSystem === "BIC_Normal" || price.taxSystem === "BIC_Simplified") {
                title += " - BIC";
            } else if (price.taxSystem === "BNC") {
                title += " - BNC";
            } else if (price.taxSystem === "RF") {
                title += " - SCI";
            }
        }
        if (price.withVAT === true) {
            title += " - avec TVA";
        } else if (price.withVAT === false) {
            title += " - sans TVA";
        }
        if (price.maxAccountingLineCount) {
            title += " - avec moins de " + price.maxAccountingLineCount + " lignes";
        } else if (price.minAccountingLineCount) {
            title += " - avec plus de " + (price.minAccountingLineCount - 1).toString() + " lignes";
        }
        if (!title) {
            title = price.title;
        }
        price.title = title;
        return title;
    }

    back() {
        this.priceList = _.cloneDeep(this.defaultPriceList);
        this.newPrice = _.cloneDeep(this.defaultPrice);
        this.step = "priceListTable";
    }

    showClientDialog(item) {
        this.priceListName = item.name;
        this.priceListClients = item.accountingFirms;
        this.clientListDialog = true;
    }

    editPriceList(list, newList: boolean = false) {
        if (list) {
            if (newList) {
                this.priceList = _.cloneDeep(list);
                this.priceList.id = "";
                if (this.priceList.prices) {
                    for (const price of this.priceList.prices) {
                        price.id = "";
                    }
                }
            } else {
                this.priceList = list;
            }
        } else {
            this.priceList = _.cloneDeep(this.defaultPriceList);
        }

        this.step = "priceListData";
    }

    invalidRow() {
        if (this.priceList.version === 1) {
            if (this.newPrice.unitPrice > 0 && this.newPrice.accountingType) {
                return false;
            }
        } else {
            if (this.newPrice.unitPrice > 0 && this.newPrice.offer) {
                return false;
            }
        }

        return true;
    }

    addRow() {
        this.priceList.prices.push({ ...this.newPrice });
        this.newPrice = _.cloneDeep(this.defaultPrice);
    }

    deleteRow(index) {
        this.priceList.prices.splice(index, 1);
    }

    @Apollo({
        query: PRICE_LISTS,
        variables() {
            return {
                version: this.version || undefined,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.priceListItems = data.bobbeePriceLists;
                }
            }
        },
    })
    priceListItems = [];

    async upsertPriceList() {
        const { data } = await this.$apollo.mutate({
            mutation: UPSERT_PRICE_LIST,
            variables: {
                id: this.accountingFirmId,
                priceList: this.priceList,
            },
        });
        this.step = "priceListTable";
        this.priceList = _.cloneDeep(this.defaultPriceList);
        this.refresh();
    }

    async deletePriceList(toDeleteId) {
        await this.$apollo.mutate({
            mutation: DELETE_PRICE_LIST,
            variables: {
                id: toDeleteId,
            },
        });
        // this.step = "priceListTable"
        this.refresh();
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.priceListItems) {
            this.$apollo.queries.priceListItems.refetch();
        } else {
            debugger;
        }
    }

    async modifyDepracated(item) {
        // debugger
        await this.$apollo.mutate({
            mutation: gql`
                mutation modifyDepracated($id: ID!, $deprecated: Boolean!) {
                    updateBobbeePriceList(where: { id: $id }, data: { deprecated: $deprecated }) {
                        id
                    }
                }
            `,
            variables: {
                id: item.id,
                deprecated: item.deprecated,
            },
        });
        // this.products.filter(x => x.id !== id)
    }

    disabledAdd() {
        if (!this.priceListItems.find((pl) => pl.type === "EXPERT" && pl.version === 2)) {
            return true;
        }
        if (!this.priceListItems.find((pl) => pl.type === "BUSINESS" && pl.version === 2)) {
            return true;
        }
        return false;
    }
}

export default toNative(PriceList);
</script>
